import React from 'react';

import styled from 'styled-components';
const StyledSmallHeadingSpan = styled.span`
  font-size: 75%;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: -0.25pt;
`;
type Props = {
  label: string;
  children: JSX.Element;
};
export function AddItemFormBox({label, children}: Props): JSX.Element {
  return (
    <div
      className="row py-2 mb-3 border-top border-bottom"
      style={{
        background: '#e9ecef',
      }}
    >
      <div className="col-12 text-muted pb-1">
        <StyledSmallHeadingSpan>{label}</StyledSmallHeadingSpan>
      </div>
      <div className="col-12">{children}</div>
    </div>
  );
}
